import { TMessageSchema } from '../../types/messages';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TMessagesMap } from '../../utils/messageUtils';
import { IActiveReplyMessage } from '../../types/messageReply';

export enum EChatActionTypes {
  IncomingMessage = 'chat/incomingMessage',
  SetEditableMessage = 'chat/setEditableMessage',
  SetCaptchaToken = 'chat/setCaptchaToken',
  DisableSendDefaultMessage = 'chat/disableSendDefaultMessage',
  SetBubbleInputFocus = 'chatWindow/setBubbleInputFocus',
  SetActiveReplyMessage = 'chat/setActiveReplyMessage',
  ClearActiveReplyMessage = 'chat/clearActiveReplyMessage',
}

export type TEditableMessagePayload = {
  chatId: string;
  text: string;
  payload?: string | null;
};

export type TSetCaptchaTokenPayload = {
  chatId: string;
  captchaToken?: string;
};

export type TIncomingMessagePayload = {
  message: TMessageSchema;
  messagesMap: TMessagesMap;
};

export type TDisableSendDefaultMessagePayload = {
  chatId: string;
};

export type TBubbleInputFocusPayload = {
  isBubbleInputFocused: boolean;
};

export type TSetActiveReplyMessagePayload = {
  chatId: string;
  reply: IActiveReplyMessage;
};

export type TClearActiveReplyMessagePayload = {
  chatId: string;
};

export type TChatActions =
  | ITypedReduxAction<EChatActionTypes.IncomingMessage, TIncomingMessagePayload>
  | ITypedReduxAction<EChatActionTypes.SetEditableMessage, TEditableMessagePayload>
  | ITypedReduxAction<EChatActionTypes.SetCaptchaToken, TSetCaptchaTokenPayload>
  | ITypedReduxAction<EChatActionTypes.DisableSendDefaultMessage, TDisableSendDefaultMessagePayload>
  | ITypedReduxAction<EChatActionTypes.SetBubbleInputFocus, TBubbleInputFocusPayload>
  | ITypedReduxAction<EChatActionTypes.SetActiveReplyMessage, TSetActiveReplyMessagePayload>
  | ITypedReduxAction<EChatActionTypes.ClearActiveReplyMessage, TClearActiveReplyMessagePayload>;
